<template>
    <Popup v-model="show" :title="title" v-model:refresh="state.refreshing" @refresh="refresh" :empty="list.finished && !list.data.length">
        <template #title>
            <div class="list-title" v-for="item in titleList" :key="item">{{ $t(item) }}</div>
        </template>
        <van-list v-model:loading="list.loading" :finished="list.finished" :loading-text="$t('Loading_please_wait')" @load="onLoad">
            <div class="list-item" v-for="(item, index) in list.data" :key="index">
                <div class="info"><img :src="item.avatar || item._source.avatar" />{{ item.uid || item._source.uid }}</div>
                <!-- <div v-if="type === 'invite'">Yes</div> -->
                <div v-if="type === 'allinvite'">{{ dayjs(item._source.time).format('YYYY/MM/DD HH:mm:ss') }}</div>
                <div v-else-if="type === 'bet'">{{ formatLocalMoney(item.totalBet) }}</div>
                <!-- 达到vip和下注额的列表使用这个 是Yes或No的图标 -->
                <div v-else :class="{ error: !item.finish }">{{ item.finish ? 'Yes' : 'No' }}</div>
                <div></div>
            </div>
        </van-list>
    </Popup>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import { usePagation } from '@/hooks/usePagation'
import { decodeName } from '@/utils'
import { formatLocalMoney } from '@/utils/toolsValidate'
// import { useBaseStore } from '@/stores'
import { useRouter } from 'vue-router'
import { getPromoterInvite, getTaskList } from '@/api/earnCash'

const props = defineProps({
    type: {
        type: String,
        default: () => 'allinvite',
    },
    id: {
        type: String,
        default: () => '',
    },
})
const show = defineModel()
const router = useRouter()
const title = computed(() => {
    return props.type == 'allinvite' ? 'earncash.earned_invite' : 'earncash.earn_details'
})

watch(
    () => show.value,
    (newVal) => {
        if (newVal) {
            refresh()
        }
    }
)

const { list, start } = usePagation()
const titleMap = {
    allinvite: 'earncash.earned_bindtime',
    invite: 'earncash.earned_placedbet',
    firstpay: 'earncash.firstpay_earncash',
    vip: 'earncash.vip_earncash',
    bet: 'earncash.earned_totalbet',
}

const titleList = computed(() => {
    return ['earncash.earned_id', titleMap[props.type], '']
})

const state = reactive({
    refreshing: false,
    empty: false,
})
const onLoad = async () => {
    list.loading = true
    try {
        let res = null
        if (props.type === 'allinvite') {
            res = await getPromoterInvite({ from: start.value, size: list.pageSize })
        } else {
            res = await getTaskList({ id: props.id, from: start.value, size: list.pageSize })
        }
        if (res.code === 200) {
            if (state.refreshing) {
                list.data = [...res.data]
            } else {
                list.data = [...list.data, ...res.data]
            }
            if (res.data.length < list.pageSize) {
                list.finished = true
            }
        } else {
            list.finished = true
        }
    } catch (e) {
        list.finished = true
    } finally {
        list.loading = false
        list.pageNum++
    }
}
const refresh = async () => {
    state.refreshing = true
    list.pageNum = 1
    list.finished = false
    await onLoad()
    state.refreshing = false
}
const goChat = (item) => {
    // 这里传用户昵称 id ， isRs代表是不是reseller用户
    router.push({
        path: '/chat',
        query: {
            nickname: decodeName(item.nickname),
            userID: item.uid,
            isRs: Number(false),
        },
    })
}
</script>
<style lang="scss" scoped>
@use './common.scss' as *;

.list-title {
    flex: 2;

    &:first-child {
        text-indent: -80px;
    }

    &:last-child {
        flex: 1;
    }
}
.list-item {
    .info {
        @apply flex items-center gap-[11px];
        img {
            width: 62px;
            height: 62px;
            border-radius: 50%;
            object-fit: cover;
        }
    }
    & > div {
        flex: 2;

        &:last-child {
            flex: 1;
            text-align: right;
            .anticon {
                margin-right: 20px;
                font-size: 32px;
            }
        }

        &:nth-child(2) {
            color: #36ff62;
            font-size: 22px;
            font-weight: 700;
            &.error {
                color: #ff3636;
            }
        }
    }
}
</style>
